// extracted by mini-css-extract-plugin
module.exports = {"Box":"about_Box__jjG9n","box":"about_box__2TP5b","span":"about_span__tD1Ur","para":"about_para__1RREC","button":"about_button__jB9K6"};